import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect () {
    // Проверяем сразу и после turbo:render
    this.scrollToFirstError()

    this.turboRenderHandler = () => this.scrollToFirstError()
    document.addEventListener('turbo:render', this.turboRenderHandler)
  }

  disconnect () {
    document.removeEventListener('turbo:render', this.turboRenderHandler)
  }

  scrollToFirstError () {
    const firstError = this.element.querySelector('.form__error, .form__input-errored')
    if (!firstError) return

    const field = firstError.closest('.form__group') || firstError
    field.scrollIntoView({ behavior: 'smooth', block: 'center' })

    const input = field.querySelector('input:not([type="hidden"]), textarea, select')
    if (input) setTimeout(() => input.focus(), 300)
  }
}
